import React, {createContext, useContext} from 'react'
import PropTypes from 'prop-types'

/**
 * Context that lets a `GDIRewardTileBlock` advertise its CMS-authored
 * `Type` (e.g. "Exclusive Rewards", "Earn Actions") and `ReferenceID`
 * to any descendant block — such as a nested `GDICustomDrawer` or
 * `GDITextBlock` — so they can adapt their rendering without
 * prop-drilling through the generic content switch.
 *
 * `voucherCode` is the optional promo/voucher string returned by the
 * Salesforce Loyalty `sync-data` API for this tile's reward (matched by
 * `tile-content-id === ReferenceID`). When set, it powers the
 * `{loyaltyVoucherCode}` dynamic tag inside descendant GDITextBlocks.
 */
const GDIRewardTileContext = createContext(null)

export const GDIRewardTileProvider = ({type, referenceID, voucherCode, children}) => (
    <GDIRewardTileContext.Provider value={{type, referenceID, voucherCode}}>
        {children}
    </GDIRewardTileContext.Provider>
)

GDIRewardTileProvider.propTypes = {
    type: PropTypes.string,
    referenceID: PropTypes.string,
    voucherCode: PropTypes.string,
    children: PropTypes.node
}

export const useGDIRewardTileContext = () => useContext(GDIRewardTileContext)

export const REWARD_TYPE_EXCLUSIVE_REWARDS = 'Exclusive Rewards'
